import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaEdit, FaSave } from "react-icons/fa";
import { useLoader } from "../../../../context/LoaderProvider.jsx";
import {
    getGroceryBillingAPI,
    saveGroceryBillingAPI,
} from "../../../Servicefile/GroceryService.jsx";
const Grocerybillingsetup = () => {
    const { showLoader, hideLoader } = useLoader();

    // ✅ Match backend field names
    const billingFields = [
        { label: "Commission", key: "commission" },
        { label: "Commission GST", key: "commissionGst" },
        { label: "GST", key: "gst" },
        { label: "Platform Fee", key: "platformFee" },
        { label: "Delivery Fee Per KM", key: "deliveryFeePerKm" },
        { label: "Partial Payment", key: "partialPayment" },
        { label: "Lead Percentage", key: "leadPercentage" },
        { label: "Coupon Amount", key: "couponAmount" },
        { label: "Top Rated", key: "topRated" },
    ];

    const [billingData, setBillingData] = useState({});
    const [editMode, setEditMode] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchBillingData();
    }, []);

    const fetchBillingData =
        async () => {
            try {
                showLoader();

                const data =
                    await getGroceryBillingAPI();

                setBillingData(
                    data
                );

            } catch (error) {
                console.error(
                    "❌ Error fetching billing data:",
                    error
                );

                alert(
                    "Failed to fetch billing data"
                );

            } finally {
                hideLoader();
            }
        };

    const toggleEdit = (key) => {
        setEditMode((prev) => ({ ...prev, [key]: !prev[key] }));
    };

    const handleValueChange = (key, value) => {
        setBillingData((prev) => ({ ...prev, [key]: value }));
    };

    const handleCheckboxChange = (key) => {
        const applicableKey = `${key}Applicable`;
        setBillingData((prev) => ({
            ...prev,
            [applicableKey]: !prev[applicableKey],
        }));
    };


    const handleSave = async () => {
        setLoading(true);

        try {
            showLoader();

            const result =
                await saveGroceryBillingAPI(
                    billingData
                );

            alert(
                result.isUpdate
                    ? "Billing updated successfully!"
                    : "Billing created successfully!"
            );

            setEditMode({});

            fetchBillingData();

        } catch (error) {
            console.error(
                "❌ Save failed:",
                error.response?.data ||
                error.message
            );

            alert(
                `Failed: ${error.response?.data
                    ?.message ||
                error.message
                }`
            );

        } finally {
            setLoading(false);

            hideLoader();
        }
    };




    return (
        <div style={containerStyle}>
            <table style={tableStyle}>
                <thead>
                    <tr>
                        <th style={headerStyle}>Charge Type</th>
                        <th style={headerStyle}>Value</th>
                        <th style={headerStyle}>Applicable</th>
                        <th style={headerStyle}>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {billingFields.map(({ label, key }) => (
                        <tr key={key}>
                            <td style={cellStyle}><strong>{label}</strong></td>
                            <td style={cellStyle}>
                                {editMode[key] ? (
                                    <input
                                        type="number"
                                        value={billingData[key] ?? ""}
                                        onChange={(e) => handleValueChange(key, e.target.value)}
                                        style={inputStyle}
                                    />
                                ) : (
                                    <span>{billingData[key] ?? "—"}</span>
                                )}
                            </td>
                            <td style={cellStyle}>
                                <input
                                    type="checkbox"
                                    checked={Boolean(billingData[`${key}Applicable`])}
                                    disabled={!editMode[key]}
                                    onChange={() => handleCheckboxChange(key)}
                                />
                            </td>
                            <td style={cellStyle}>
                                {editMode[key] ? (
                                    <FaSave
                                        onClick={() => handleSave(key)}
                                        style={{ ...iconStyle, color: "#4caf50" }}
                                        title="Save"
                                    />
                                ) : (
                                    <FaEdit
                                        onClick={() => toggleEdit(key)}
                                        style={iconStyle}
                                        title="Edit"
                                    />
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px" }}>
                <button
                    onClick={() => handleSave()}
                    style={saveButtonStyle}
                    disabled={loading}
                >
                    {loading ? "Saving..." : "Save All"}
                </button>
            </div>
        </div>
    );
};

// ✅ Styles
const containerStyle = { maxWidth: "1200px", margin: "0 auto", fontFamily: "Segoe UI, sans-serif", padding: "0px" };
const tableStyle = { width: "100%", borderCollapse: "collapse" };
const headerStyle = { background: "#b15cd6", color: "#fff", padding: "10px", border: "1px solid #ddd", textAlign: "center" };
const cellStyle = { padding: "10px", border: "1px solid #ddd", textAlign: "center" };
const inputStyle = { width: "100px", padding: "5px", border: "1px solid #ccc", borderRadius: "5px", textAlign: "center" };
const iconStyle = { fontSize: "18px", cursor: "pointer" };
const saveButtonStyle = {
    padding: "10px 20px",
    backgroundColor: "#4CAF50",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontWeight: "bold",
    transition: "background-color 0.3s",
};

export default Grocerybillingsetup;
